import { render, staticRenderFns } from "./ThemeCard.vue?vue&type=template&id=474fde85&"
import script from "./ThemeCard.vue?vue&type=script&lang=ts&"
export * from "./ThemeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports